import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notifications-container" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "notification-body" }
const _hoisted_4 = ["onClick"]

import { useNotificationStore } from '@/stores/notifications'
import { computed } from 'vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'AllNotifications',
  setup(__props) {


const notificationStore = useNotificationStore()
const allNotifications = computed(() => notificationStore.notifications)




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allNotifications.value, (notification) => {
        return (_openBlock(), _createElementBlock("div", {
          key: notification.id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([`bg-${notification.type}`, "notification"]),
            role: "alert"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(notification.message), 1),
              _createElementVNode("button", {
                "aria-label": "Close",
                class: "btn-close btn-close-white btn-sm ms-auto me-2",
                type: "button",
                onClick: () => _unref(notificationStore).removeFromNotifications(notification)
              }, null, 8, _hoisted_4)
            ])
          ], 2)
        ]))
      }), 128))
    ])
  ]))
}
}

})